/**
 * @fileoverview QuicksearchInput — the large search input at the top of
 * the Quicksearch dialog. Leading `bp6-icon-search` (20px), trailing
 * `bp6-icon-cross` close button. Uncontrolled by default; pass `value` +
 * `onChange` for controlled use.
 *
 * Foundry mapping: `bp6-input-group bp6-large
 * quicksearch-dialog__input-group__2p4gjw`.
 */

import { Button, Icon, InputGroup } from "@blueprintjs/core";
import type { ChangeEvent, ReactElement } from "react";

interface QuicksearchInputProps {
  value?: string;
  onChange?: (next: string) => void;
  onClose?: () => void;
  placeholder?: string;
  autoFocus?: boolean;
  className?: string;
}

export function QuicksearchInput({
  value,
  onChange,
  onClose,
  placeholder = "Search for anything in your enterprise…",
  autoFocus = true,
  className,
}: QuicksearchInputProps): ReactElement {
  return (
    <div data-testid="quicksearch-input" className={["bp-quicksearch-input-wrapper", className].filter(Boolean).join(" ")}>
      <InputGroup
        data-testid="quicksearch-input-field"
        type="search"
        large
        autoFocus={autoFocus}
        value={value}
        onChange={(e: ChangeEvent<HTMLInputElement>) => onChange?.(e.target.value)}
        leftElement={
          <span className="bp-quicksearch-input-left">
            <Icon icon="search" size={20} />
          </span>
        }
        rightElement={
          onClose ? (
            <Button
              data-testid="quicksearch-input-close"
              minimal
              icon="cross"
              aria-label="Close Quicksearch"
              onClick={onClose}
            />
          ) : undefined
        }
        placeholder={placeholder}
        className="bp-quicksearch-input"
      />
    </div>
  );
}
